import { memo } from "react"

const PlayerActions = ((props) => {


    return <div className="truco-player-action-buttons">
        {
            props.playerActions.map((ele, ind) => <button type="button" tabIndex={0} onClick={() => { props.sendPlayerAction(ele) }} className="truco-player-action-btn truco-button">{ele.replaceAll("_", " ")}</button>)
        }
    </div>
})

export default memo(PlayerActions)